export default __webpack_public_path__ + "static/media/detail_big_2_5.cc908114.png";